import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';

const SimpleModal: React.FC<{
  contact: any;
  header: string;
  request_action: string;
  title: JSX.Element;
  confirm: string;
  cancel: string;
  state: boolean;
  onClose: (todo: boolean) => void;
  onSave: () => void;
}> = ({
  contact,
  header,
  request_action,
  title,
  confirm,
  cancel,
  state,
  onClose,
  onSave
}) => {
  const i18n = useTranslation();
  const request_type =
    (contact?.type &&
      `${request_action} ${i18n.t(
        `reference.contactType.${contact?.type}`
      )} request`) ||
    i18n.t('contactCenter.detail.manage_request.close_request');
  const product =
    (contact?.product.name &&
      contact?.product.name &&
      `for ${contact?.product.name}`) ||
    '';

  const modalHeader = header ? header : `${request_type} ${product}`;
  return (
    <>
      <Dialog
        open={state}
        aria-labelledby="contained-modal-title-vcenter"
        style={{ whiteSpace: 'pre-line' }}
      >
        <DialogTitle>{modalHeader}</DialogTitle>
        <DialogContent>{title}</DialogContent>
        <DialogActions>
          <Button color="success" onClick={() => onSave()}>
            {confirm}
          </Button>
          <Button color="error" onClick={() => onClose(false)}>
            {cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SimpleModal;
